import { useTranslation } from "react-i18next";
import FormUpload from "../../../components/formInputs/FormUpload";

interface IProps {
    poUrl: string;
    quotationUrl: string;
}

const PoQuotation = ({poUrl, quotationUrl} : IProps) => {
    const {t} = useTranslation();

    return (
        <>
        <div className="field-array-container noPadding noMarginBottom">
        <div className="field-array-container">
        <div className="fields_container" style={{padding: "2rem"}}>
                <div className='file'
                //  onClick={() => !canEdit && setUnauthorized(true)}
                    >
    
        <FormUpload
          name={`poFile`}
          fileName={t("poFile")}
          label={t("po")}
        />
   
    </div>
    <div className='file'>
    
        <FormUpload
          name={`quotationFile`}
          fileName={t("quotationFile")}
        //   isCurrentStep={isCurrentStep}
          label={t("quotation")}
        />
   
    </div>
            </div>
      </div>
      </div>
        </>
    );
}

export default PoQuotation;